import { TopUpData } from '@/pdf/templates/TopUpPDF';
import { formatTSh } from '@/lib/currency';

export const DEFAULT_RATE_PER_KWH = 400;

export function calculateKwh(amount: number, ratePerKwh: number = DEFAULT_RATE_PER_KWH): string {
  const rate = ratePerKwh > 0 ? ratePerKwh : DEFAULT_RATE_PER_KWH;
  return `${(amount / rate).toFixed(2)} kWh`;
}

export interface ReceiptParams {
  id: string;
  reference?: string | null;
  amount: number;
  completedAt: string;
  customerName: string;
  ratePerKwh?: number;
  meterNumber?: string | null;
  apartmentNumber?: string | null;
  buildingName?: string | null;
  paymentMethod?: string;
  organizationName?: string | null;
  logoUrl?: string | null;
  stsToken?: string | null;
}

export function buildTopUpData(params: ReceiptParams): TopUpData {
  return {
    reference: params.reference || params.id.padStart(8, '0'),
    issueDate: new Date(params.completedAt).toLocaleString(),
    amount: formatTSh(params.amount),
    amountKwh: calculateKwh(params.amount, params.ratePerKwh),
    customerName: params.customerName || undefined,
    meterNumber: params.meterNumber || undefined,
    apartmentNumber: params.apartmentNumber || undefined,
    buildingName: params.buildingName || undefined,
    paymentMethod: params.paymentMethod || 'Mobile Money',
    stsToken: params.stsToken ? String(params.stsToken).replace(/\D/g, '') : undefined,
    status: 'completed',
    organizationName: params.organizationName || undefined,
    logoUrl: params.logoUrl || undefined,
  };
}
